import React from 'react';
import { Box, Typography, Link, Grid, IconButton, Stack } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useNavigate } from 'react-router-dom';

function Footer() {
    const navigate = useNavigate();
    const navToTerms = () => {
        navigate('/conditions-dutilisation');
    }
    const navToConfidentiality = () => {
        navigate('/politique-de-confidentialite');
    }
    const navToFaq = () => {
        navigate('/faq');
    }
    const navToForm = () => {
        navigate('/contact');
    }
    const navToTMDB = () => {
        window.open('https://www.themoviedb.org/', '_blank');
    }
    return (
        <Box component="footer" sx={{
            bgcolor: 'rgb(37, 150, 190)', width: '100%', color: 'white', p: 4, mt: '50px', zIndex: 1300, // Z-index élevé pour être au-dessus du Drawer
            position: 'relative', // Fixe le footer en bas
            bottom: 0, // Positionne le footer en bas
            left: 0,
        }}>
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} sm={4}>
                    <Typography sx={{ fontFamily: 'SUSE, sans-serif' }} variant="h6">À propos</Typography>
                    <Typography sx={{ fontFamily: 'SUSE, sans-serif' }} variant="body2">
                        Une plateforme dédiée aux meilleurs K-Dramas. Découvrez, explorez vos K-Dramas préférés !
                    </Typography>

                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography sx={{ fontFamily: 'SUSE, sans-serif' }} variant="h6">Liens Utiles</Typography>
                    <Stack direction="column" spacing={1}>
                        <Link onClick={navToTerms} color="inherit" sx={{ fontFamily: 'SUSE, sans-serif', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} underline="none">Conditions d'utilisation</Link>
                        <Link onClick={navToConfidentiality} color="inherit" sx={{ fontFamily: 'SUSE, sans-serif', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} underline="none">Politique de confidentialité</Link>
                        <Link onClick={navToFaq} color="inherit" sx={{ fontFamily: 'SUSE, sans-serif', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} underline="none">FAQ</Link>
                        <Link onClick={navToForm} color="inherit" sx={{ fontFamily: 'SUSE, sans-serif', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} underline="none">Signaler un bug ou tout autre demande</Link>
                        <Link onClick={navToTMDB} color="inherit" sx={{ fontFamily: 'SUSE, sans-serif', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }} underline="none">Utilisation de l'api TMDB </Link>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography sx={{ fontFamily: 'SUSE, sans-serif' }} variant="h6">Suivez-nous</Typography>

                    <IconButton color="inherit" href="#" aria-label="Instagram">
                        <InstagramIcon />
                    </IconButton>
                </Grid>
            </Grid>
            <Typography variant="body2" align="center" sx={{ fontFamily: 'SUSE, sans-serif', mt: 4 }}>
                &copy; {new Date().getFullYear()} K-Drama App. Tous droits réservés.
            </Typography>
        </Box>
    );
}

export default Footer;
